const WeekPicker = ({ disabled, weekBehind, weekAhead, value, disableBack }) => {
  return (
    <div className="flex">
      <button
        className={`hover:opacity-75 ${(disabled || disableBack) ? 'opacity-30 cursor-not-allowed' : ''}`}
        onClick={weekBehind}
        disabled={disabled || disableBack}
        title={disableBack ? "Historical data limit reached" : "Previous week"}
        aria-label={disableBack ? "Previous week - Historical data limit reached" : "Previous week"}
      >
        <span className="arrow arrow-right"></span>
      </button>
      <div className="h-full min-w-[90px] flex items-center justify-center bg-yellow-30 text-black px-2">
        <span>{value}</span>
      </div>
      <button
        className="hover:opacity-75"
        onClick={weekAhead}
        disabled={disabled}
        title="Next week"
        aria-label="Next week"
      >
        <span className="arrow"></span>
      </button>
    </div>
  );
};

export default WeekPicker;
